import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import Img from "../../Images/profile.jpg";
import Toolstack from "./Toolstack";
import Education from "./Education";
import {
  slideInRight,
  bounceIn,
  slideInLeft,
  slideInUp,
  slideInDown,
} from "react-animations";
import Radium, { StyleRoot } from "radium";
import Experience from "./Experience";

function About() {
  const styles = {
    slideInLeft: {
      animation: "x 3s",
      animationName: Radium.keyframes(slideInLeft, "bounce"),
    },
    slideInUp: {
      animation: "x 3s",
      animationName: Radium.keyframes(slideInUp, "bounce"),
    },
    slideInRight: {
      animation: "x 3s",
      animationName: Radium.keyframes(slideInRight, "bounce"),
    },
    bounceIn: {
      animation: "x 3s",
      animationName: Radium.keyframes(bounceIn, "bounce"),
    },
    slideInDown: {
      animation: "x 3s",
      animationName: Radium.keyframes(slideInDown, "bounce"),
    },
  };
  return (
    <StyleRoot>
      <Container fluid className="about-section">
        <Particle />
        <Container>
          <Row style={{ justifyContent: "center", padding: "10px" }}>
            <Col
              md={7}
              style={{
                justifyContent: "center",
                paddingTop: "30px",
                paddingBottom: "50px",
              }}
            >
              <div style={styles.bounceIn}>
                {<h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
                  Know about <strong className="purple">Me</strong>
                </h1>}
              </div>
              <div style={styles.slideInLeft}>

                <Aboutcard />
              </div>

            </Col>
            <Col
              md={5}
              style={{ paddingTop: "120px", paddingBottom: "50px" }}
              className="about-img"
            >
              <div style={styles.bounceIn}>

                <img style={{ height: '350px', width: '350px', borderRadius: '20px' }} src={Img} alt="about" className="img-fluid" />
              </div>

            </Col>
          </Row>
          <Experience></Experience>
          <br />
          <br />
          <Education />
          <br />
          <br />

          <h1 className="project-heading">
            <strong className="purple">Skillset </strong>
          </h1>

          <Techstack />

          <h1 className="project-heading">
            <strong className="purple">Tools</strong>
          </h1>
          <Toolstack />

        </Container>
      </Container>
    </StyleRoot>
  );
}

export default About;
